export default "<!--\n<div class=\"app-opacity\">\n    <div class=\"app-loading\">\n    </div>\n</div>\n-->\n";